<template lang="pug">
  div.lmm-content-body-padded
    //sub-header
    //b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone")
    //  b-button(variant="link", size="sm", style="max-width: 100%", target="_blank", href="https://linkmemine.co.kr/faq/p/manager_guide_topic_10.php")
    //    icon(name="bookmark", style="margin:0 4px 0 2px;")
    //    span {{$t('tutorial-group')}}
    b-container(fluid)
      router-view
</template>

<script>
export default {
  name: 'groups-component'
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
}

.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}
</style>
